var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 4000 4000",
    style: {
      enableBackground: "new 0 0 4000 4000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, " -->\n", /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "125px",
    height: "125px",
    viewBox: "0 0 3750 2750",
    style: {
      enableBackground: "new 0 0 4000 4000",
      display: "block",
      margin: "auto"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000154383986265085843050000012689169117315227271_);}\n\t.st2{fill:url(#SVGID_00000158731234498507113340000014116102205641095554_);}\n\t.st3{fill:url(#SVGID_00000016774698784879922000000008084358627052214171_);}\n\t.st4{fill:#EBC333;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 1997.1674,
    y1: 1243.6279,
    x2: 1997.1674,
    y2: 1453.2305
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E7B813"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D2A224"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2182.73,1360.75c0-76.56-30.62-145.95-80.27-196.64l-130.47,131.59l-0.84,0.74   c-16.91-17.01-40.32-27.54-66.2-27.54c-51.55,0-93.34,41.79-93.34,93.34c0,51.55,41.79,93.34,93.34,93.34   c26.02,0,49.56-10.65,66.48-27.83l129.82,130.89C2151.61,1507.84,2182.73,1437.93,2182.73,1360.75z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000123413125197247195210000010617654923801714587_",
    gradientUnits: "userSpaceOnUse",
    x1: 1902.2682,
    y1: 863.7001,
    x2: 1902.2682,
    y2: 1087.6216
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C99929"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCAD19"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000123413125197247195210000010617654923801714587_)"
    },
    d: "M1706.04,1158.98   c50.6-49.07,119.58-79.29,195.63-79.29c78.67,0,149.77,32.33,200.79,84.42l0,0l126.19-131.21   c-83.76-83.54-199.33-135.19-326.98-135.19c-127.04,0-242.12,51.16-325.78,134L1706.04,1158.98z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147922098870010359820000005740108430765792650_",
    gradientUnits: "userSpaceOnUse",
    x1: 1902.8556,
    y1: 1635.1271,
    x2: 1902.8556,
    y2: 1797.5396
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EDCD63"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ECC026"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000147922098870010359820000005740108430765792650_)"
    },
    d: "M2101.25,1558.63L2101.25,1558.63   c-50.93,51.36-121.54,83.18-199.58,83.18c-78.05,0-148.66-31.82-199.58-83.18l-0.01,0l-125.85,131.49l0,0   c83.63,82.64,198.57,133.67,325.44,133.67c128.07,0,243.99-51.99,327.81-136.02L2101.25,1558.63z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000143578317342074975520000006884469976118914962_",
    gradientUnits: "userSpaceOnUse",
    x1: 1838.4767,
    y1: 813.9987,
    x2: 1788.2136,
    y2: 1964.9912
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0757,
    style: {
      stopColor: "#D7A81D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1113,
    style: {
      stopColor: "#DAAD29"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1755,
    style: {
      stopColor: "#E1BB48"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2604,
    style: {
      stopColor: "#ECD17B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2742,
    style: {
      stopColor: "#EED584"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3523,
    style: {
      stopColor: "#EED481"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#EDD278"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461,
    style: {
      stopColor: "#ECCD68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5083,
    style: {
      stopColor: "#EAC751"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5525,
    style: {
      stopColor: "#E8C034"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5913,
    style: {
      stopColor: "#E6B714"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7246,
    style: {
      stopColor: "#E3B416"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9087,
    style: {
      stopColor: "#C2922E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000143578317342074975520000006884469976118914962_)"
    },
    d: "M2229.48,1687.77L2229.48,1687.77   c-83.82,84.03-199.74,136.02-327.81,136.02c-255.73,0-463.03-207.31-463.03-463.03s207.31-463.03,463.03-463.03   c128.16,0,244.16,52.07,328,136.22l136.36-139.54c-119.02-118.51-283.14-191.77-464.37-191.77   c-363.48,0-658.13,294.65-658.13,658.13s294.65,658.13,658.13,658.13c181.18,0,345.25-73.22,464.26-191.67L2229.48,1687.77z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c8fef02c08bb2e2e0237d58aa58509cf.svg";
export { ForwardRef as ReactComponent };